import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';

interface UiPaginationArrowSignature {
  Args: {
    direction: 'left' | 'right';
    disabled?: boolean;
    onClick: () => void;
  };
  Element: HTMLButtonElement;
}

export default <template>
  <button
    {{on "click" @onClick}}
    class="pagination-arrow btn btn--square btn--outlineFill inline-block
      {{if (eq @direction 'left') 'icon-arrow-left-large mr-1'}}
      {{if (eq @direction 'right') 'icon-arrow-right-large'}}
      {{if @disabled ' disabled '}}
      "
    data-test-ui-pagination-arrow={{@direction}}
    type="button"
    ...attributes
  >
    &nbsp;
  </button>
</template> satisfies TOC<UiPaginationArrowSignature>;
